import { Link } from 'react-router-dom';
import Header from '../../components/public/Header';
import Footer from '../../components/public/Footer';

/**
 * Protective holding view, not a substitute for approved CareDock legal terms.
 * A care-provider tenant's legal documents cannot represent the platform operator.
 * The launch gate is to publish verified platform policies before broad release.
 */
export default function CareDockLegalPending({ type }) {
  const isPrivacy = type === 'privacy';
  return (
    <div className="flex min-h-screen flex-col bg-[#f6f9fc] text-[#0D274E]" data-testid="caredock-legal-pending">
      <Header minimal />
      <main className="flex flex-1 items-center justify-center px-5 py-20">
        <section className="w-full max-w-2xl rounded-[22px] border border-[#dce8f0] bg-white p-8 sm:p-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#007bb4]">CareDock platform</p>
          <h1 className="mt-4 font-heading text-3xl font-semibold">{isPrivacy ? 'Privacy notice' : 'Platform terms'}</h1>
          <p className="mt-4 text-base leading-7 text-[#4d6277]">
            {isPrivacy
              ? 'The CareDock platform privacy notice is being prepared for publication.'
              : 'The CareDock platform terms are being prepared for publication.'}
          </p>
          <p className="mt-3 text-sm leading-6 text-[#667b8d]">
            This is not an Osabea Healthcare Solutions Ltd policy. Osabea is a care-provider tenant; it does not represent CareDock as the platform.
          </p>
          <p className="mt-3 text-sm leading-6 text-[#667b8d]">
            We are not collecting new provider enquiries through this page. If your organisation has invited you, use its existing secure workspace link.
          </p>
          <Link to="/access" className="mt-7 inline-flex min-h-11 items-center rounded-xl bg-[#0D274E] px-6 py-3 text-sm font-semibold text-white hover:bg-[#163e6c]">
            Access your workspace
          </Link>
        </section>
      </main>
      <Footer minimal />
    </div>
  );
}
